 <template>
  <b-table :data="rows" :paginated="true" :per-page="20">
    <template slot-scope="props">
      <b-table-column field="email" label="Email" sortable>{{ props.row.email }}</b-table-column>

      <b-table-column field="shop" label="Shop" sortable>
        <a :href="props.row.shop" target="_blank">{{ truncate(props.row.shop, 36) }}</a>
      </b-table-column>

      <b-table-column field="reject" label="Reject">
        <b-button type="is-danger" @click="() => rejectUser(props.row)">Reject</b-button>
      </b-table-column>
      <b-table-column field="approve" label="Approve">
        <b-button type="is-success" @click="() => approveUser(props.row)">Approve</b-button>
      </b-table-column>
    </template>
  </b-table>
</template>

<script>
import { mapGetters } from "vuex";
import firebase from "firebase";

export default {
  name: "AdminUsersPending",
  data() {
    return {
      rows: []
    };
  },
  created() {
    const db = firebase.firestore();
    db.collection("user")
      .where("status", "==", "pending")
      .get()
      .then(querySnapshot => {
        const rows = [];
        querySnapshot.forEach(doc => {
          const data = doc.data();
          data.id = doc.id;
          rows.push(data);
        });
        this.rows = rows;
      })
      .catch(function(error) {
        console.log("Error getting documents: ", error);
      });
  },
  computed: {
    ...mapGetters({
      // map `this.user` to `this.$store.getters.user`
      user: "user"
    })
  },
  methods: {
    truncate: (string, n) => {
      return string.length > n ? string.substr(0, n - 1) + "..." : string;
    },
    approveUser: function(user) {
      this.setStatus(user, "approved");
    },
    rejectUser: function(user) {
      this.setStatus(user, "rejected");
    },
    setStatus: function(user, status) {
      const db = firebase.firestore();
      var userRef = db.collection("user").doc(user.id);
      console.log(user.id);
      return userRef
        .update({
          status
        })
        .then(() => {
          console.log(`Document ${user.id} successfully updated!`);
          this.rows = this.rows.filter(row => row.id !== user.id);
        })
        .catch(function(error) {
          console.error(`Error updating document ${user.id}: ${error}`);
        });
    }
  }
};
</script>
